import api from '@/api';

class JobRequest {
  /**
   * @returns {number}
   * @constructor
   */
  static NEW_JOB_REQUEST_ID() {
    return 1;
  }

  /**
   * @returns {number}
   * @constructor
   */
  static ADDITION_TO_JOB_ID() {
    return 2;
  }

  /**
   * @returns {number}
   * @constructor
   */
  static REMOVAL_FROM_JOB_ID() {
    return 3;
  }

  /**
   * @returns {number}
   * @constructor
   */
  static CANCEL_JOB_REQUEST() {
    return 4;
  }

  static STATUS_PENDING() {
    return 1;
  }

  /**
   * Index / Get listing of job requests
   * @returns {*}
   */
  static list(params) {
    return api.get('/job-requests', { params });
  }

  /**
   * @param name
   * @param complianceTypeId
   * @param assessmentTypeId
   * @param propertyIds
   * @param jobRequestTypeId
   * @param jobId
   * @param removalReason
   * @returns {Promise<AxiosResponse<T>>}
   */
  static add(name, complianceTypeId, assessmentTypeId, propertyIds, jobRequestTypeId, jobId = 0, removalReason = null) {
    return api.post(
      '/job-requests',
      {
        name,
        complianceTypeId,
        assessmentTypeId,
        propertyIds,
        jobRequestTypeId,
        jobId,
        removalReason,
      },
    );
  }

  /**
   * Get job request
   * @param jobRequestId
   * @returns {*}
   */
  static find(jobRequestId) {
    return api.get(`/job-requests/${jobRequestId}`);
  }

  /**
   * Get job request properties
   * @param jobRequestId
   * @returns {*}
   */
  static getProperties(jobRequestId) {
    return api.get(`/job-requests/${jobRequestId}/properties`);
  }

  /**
   * Cancel job request
   * @param jobRequestId
   * @param cancellationReason
   * @returns {*}
   */
  static cancel(jobRequestId, cancellationReason) {
    return api.put(`/job-requests/${jobRequestId}/cancel`, { cancellationReason });
  }
}

export default JobRequest;
